import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import Rapid7InsightConfligListing from './Rapid7InsightConfligListing';
import Rapid7InsightCredentialsForm from './Rapid7InsightCredentialsForm';

const Rapid7InsightPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={Rapid7InsightCredentialsForm}
        PullConfigListingView={Rapid7InsightConfligListing}
     />
);

export default Rapid7InsightPullAndPushView;
